import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-start gap-3 text-left pr-8" }
const _hoisted_2 = { class: "w-10 h-10 shrink-0 rounded-full bg-red-50 flex items-center justify-center" }
const _hoisted_3 = {
  viewBox: "0 0 24 24",
  class: "w-6 h-6 text-negative",
  "aria-hidden": "true"
}
const _hoisted_4 = ["d"]
const _hoisted_5 = { class: "text-lg font-bold text-textPrimary" }
const _hoisted_6 = { class: "text-sm text-[#52526f]" }
const _hoisted_7 = {
  class: "flex flex-col gap-4 text-left",
  "data-testid": "pre-allocation-blocked-modal"
}
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-textPrimary" }, "O que falta", -1)
const _hoisted_10 = { class: "text-sm font-semibold text-textPrimary" }
const _hoisted_11 = {
  key: 0,
  class: "text-xs text-negative"
}
const _hoisted_12 = {
  key: 1,
  class: "text-sm text-[#52526f]",
  "data-testid": "pre-allocation-blocked-fallback"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-lg bg-[#f0f0f4] p-3 text-[13px] text-[#52526f] flex flex-col gap-1.5" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", { class: "text-textPrimary" }, "As colunas andam sozinhas."),
    /*#__PURE__*/_createTextVNode(" A demanda vai para Resolvido quando todos os documentos exigidos estiverem Concluídos — aí a pré-alocação vira definitiva e o médico recebe push. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Não existe liberação manual: documento pendente sempre bloqueia o “Resolvido”.")
], -1)
const _hoisted_14 = { class: "text-xs text-[#7f7f8e]" }
const _hoisted_15 = { class: "flex flex-col sm:flex-row sm:justify-end gap-3" }

import { computed } from 'vue'
import { mdiLockAlertOutline } from '@mdi/js'

import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { ProfessionalDocumentStatus } from '@/types/professional-documents.types'
import type { PreAllocationColumn } from '@/types/qualification-eligibility.types'

import { PRE_ALLOCATION_COLUMN_LABEL, formatStationStart } from '../model'
import type { PreAllocationStation } from '../model'

export interface BlockedItem {
  key: string
  name: string
  status: ProfessionalDocumentStatus
  /** Por que está Pendente ("Nunca enviado", "Vencido", "Reprovado"); vazio no Em Análise. */
  detail: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PreAllocationBlockedModal',
  props: {
    modelValue: { type: Boolean },
    professionalName: {},
    targetColumn: {},
    items: {},
    nearestStation: {}
  },
  emits: ["update:modelValue", "review"],
  setup(__props: any, { emit }) {

const props = __props;




const isInReview = (item: BlockedItem) => item.status === ProfessionalDocumentStatus.IN_REVIEW
const hasInReview = computed(() => props.items.some(isInReview))

function close() {
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "max-width": "max-w-[520px]",
    onClose: close
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock("svg", _hoisted_3, [
            _createElementVNode("path", {
              d: _unref(mdiLockAlertOutline),
              fill: "currentColor"
            }, null, 8, _hoisted_4)
          ]))
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("h2", _hoisted_5, " Não dá para mover para “" + _toDisplayString(_unref(PRE_ALLOCATION_COLUMN_LABEL)[_ctx.targetColumn]) + "” ", 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.professionalName) + " ainda tem documento que bloqueia a alocação definitiva. ", 1)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_15, [
        (hasInReview.value)
          ? (_openBlock(), _createBlock(OutlineButton, {
              key: 0,
              text: "Revisar documentos",
              width: "200px",
              height: "40px",
              "data-testid": "pre-allocation-blocked-review",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('review')))
            }))
          : _createCommentVNode("", true),
        _createVNode(FilledButton, {
          text: "Entendi",
          width: "140px",
          height: "40px",
          "data-testid": "pre-allocation-blocked-ok",
          onClick: close
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.items.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.key,
                  class: "flex items-start justify-between gap-3 rounded-lg border border-[#e8e8ed] px-3 py-2"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(item.name), 1),
                    (item.detail)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(item.detail), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["shrink-0 text-xs font-semibold", isInReview(item) ? 'text-[#9a6b00]' : 'text-negative'])
                  }, _toDisplayString(isInReview(item) ? 'Em Análise — depende do time' : 'Pendente — depende do médico'), 3)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_12, " Ainda há documento que bloqueia a alocação definitiva. Atualize a página para ver o que falta. ")),
        _hoisted_13,
        _createElementVNode("p", _hoisted_14, [
          (_ctx.nearestStation)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Plantão mais próximo: " + _toDisplayString(_unref(formatStationStart)(_ctx.nearestStation.start)) + " (" + _toDisplayString(_ctx.nearestStation.scheduleName) + "). ", 1)
              ], 64))
            : _createCommentVNode("", true),
          _createTextVNode(" Sem resolução até 24h antes do plantão, o médico é avisado; no início do plantão o check-in fica bloqueado e o gestor decide manter ou remover. Nada é desalocado automaticamente. ")
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})